import type { CrmOrg } from '../../../types/CrmOrgs';
import FetchProgressBar from './FetchProgressBar';
import useInitialFetchProgress from './useInitialFetchProgress';
import Stack from '@mui/material/Stack';
import { colors, Tooltip } from '@sweep-io/sweep-design';

const EnvFetchProgressBar = ({
  crmOrg,
  processPercentageFont,
  withWrapper,
}: {
  crmOrg: CrmOrg;
  processPercentageFont?: 'body' | 'caption-medium';
  withWrapper?: boolean;
}) => {
  const { progressPercentage } = useInitialFetchProgress(crmOrg);

  const fetchContent = progressPercentage ? (
    <FetchProgressBar
      progressPercentage={progressPercentage}
      totalWidth={64}
      processPercentageFont={processPercentageFont}
    />
  ) : null;

  const renderFetchContent = withWrapper ? (
    <Tooltip title="Fetching..." placement="top">
      <Stack
        sx={{
          backgroundColor: colors.white,
          p: 1,
          borderRadius: '4px',
          border: `1px solid ${colors.grey[120]}`,
          zIndex: 1,
        }}
      >
        {fetchContent}
      </Stack>
    </Tooltip>
  ) : (
    fetchContent
  );

  return progressPercentage ? renderFetchContent : null;
};

export default EnvFetchProgressBar;
